/**
 * This enum is a clever way we can tell the Success Modal in the tx builder whether or not
 * the transaction is ready to execute, or how many more approvals are needed, with just a single
 * variable. The number values correspond to how many more approvals are needed, so if zero approvals
 * are needed, it's ready to execute. And -1 represent a special state where the dialog is closed.
 */
export enum SuccessDialogState {
  Closed = -1,
  ReadyToExecute = 0,
  NeedsOneMore = 1,
  NeedsTwoMore = 2,
  NeedsThreeMore = 3,
  NeedsFourMore = 4,
  NeedsFiveMore = 5,
  NeedsSixMore = 6,
  NeedsSevenMore = 7,
  NeedsEightMore = 8,
  NeedsNineMore = 9,
  NeedsTenMore = 10,
  NeedsElevenMore = 11,
  NeedsTwelveMore = 12,
  NeedsThirteenMore = 13,
  NeedsFourteenMore = 14,
  NeedsFifteenMore = 15,
  NeedsSixteenMore = 16,
  NeedsSeventeenMore = 17,
  NeedsEighteenMore = 18,
  NeedsNineteenMore = 19,
  NeedsTwentyMore = 20,
}
